import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { first, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonConfirmActionService {
  public addPodjedinice = false;

  constructor(private confirmationService: ConfirmationService) {
    this.confirmationService = confirmationService;
  }

  resetAddPodjedinice() {
    this.addPodjedinice = false;
  }

  confirm(
    key: string
  ): Observable<{ confirmed: boolean; addPodjedinice: boolean }> {
    const accepted$ = new Subject<{
      confirmed: boolean;
      addPodjedinice: boolean;
    }>();

    this.confirmationService.confirm({
      key,
      accept: () => {
        accepted$.next({
          confirmed: true,
          addPodjedinice: this.addPodjedinice
        });
        this.resetAddPodjedinice();
        this.confirmationService.close(); // fix dokumentacija: zatvaranje postojećih dijaloga
        accepted$.complete();
      },
      reject: () => {
        accepted$.next({ confirmed: false, addPodjedinice: false });
        this.resetAddPodjedinice();
        this.confirmationService.close();
        accepted$.complete();
      }
    });

    return accepted$.asObservable().pipe(first()); // unsubscribe nakon potvrde / cancel
  }
}
